export default __webpack_public_path__ + "static/media/education-large.03ae9ded.svg";